import moment from 'moment';

export const MINIMUM_START_DATE = moment.utc('2025-06-16');
